import classNames from './ProgressCard.module.scss';
import classes from 'classnames';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import SVG from 'react-inlinesvg';
import { UnitProgress } from '@/school-management/types/response/studentDetails';

import trophy from '@/assets/svg/trophy.svg';
import medal from '@/assets/svg/medal-gold.svg';

interface ProgressCardProps {
  unitId: number;
  title: string;
  percentage: number;
  topics: {
    completed: number;
    total: number;
  } | null;
  activities: {
    completed: number;
    total: number;
  } | null;
  showViewPerformanceBtn?: boolean;
  onClick: (unitId: number, unitProgresData: UnitProgress) => void;
  className?: string;
  topicsClassName?: string;
  unitProgresData: UnitProgress;
}

const ProgressCard = ({
  unitId,
  title,
  percentage,
  topics,
  activities,
  showViewPerformanceBtn = true,
  onClick,
  className,
  topicsClassName,
  unitProgresData,
}: ProgressCardProps) => {
  const { t } = useAdminTranslation();
  const dividers = Array.from(Array(4)).map((divider, index) => {
    const left = `${20 * (index + 1)}%`;

    return <div key={index} className={classNames.divider} style={{ left }}></div>;
  });

  return (
    <div className={classes(classNames.progressCard, className)}>
      <div className={classNames.text}>
        <span>{title}</span>
        <span>{`${percentage}%`}</span>
      </div>
      <div className={classNames.details}>
        <div>
          {topics && (
            <div className={classes(classNames.bottomTextContainer, topicsClassName)}>
              <div className={classNames.textContainer}>
                <SVG src={trophy} />
                <span>{`${topics.completed}/${topics.total} ${t('studentDataModal.topics')}`}</span>
              </div>
              {activities && (
                <div className={classNames.textContainer}>
                  <SVG src={medal} />
                  <span>{`${activities.completed}/${activities.total} ${t('studentDataModal.activities')}`}</span>
                </div>
              )}
            </div>
          )}
        </div>
        <div className={classNames.progressBar}>
          <div className={classNames.dividers}>{dividers}</div>
          <div className={classNames.bar} style={{ width: `${percentage}%` }}></div>
        </div>

        {showViewPerformanceBtn && (
          <button
            className={classNames.button}
            disabled={activities?.completed === 0 && true}
            onClick={() => onClick(unitId, unitProgresData)}
          >
            {t('studentDataModal.viewPerformance')}
          </button>
        )}
      </div>
    </div>
  );
};

export default ProgressCard;
